/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupMilestoneEventsRoutingModule } from './builder-setup-milestone-events-routing.module';

import { MilestoneEventDetailsComponent } from './components/milestone-event-details/milestone-event-details.component';
import { MilestoneEventListComponent } from './components/milestone-event-list/milestone-event-list.component';
import { MilestoneEventDetailsBusinessService } from './resources/milestone-event-details-business.service';
import { MilestoneEventListBusinessService } from './resources/milestone-event-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupMilestoneEventsRoutingModule,
  ],
  providers: [
    MilestoneEventListBusinessService,
    MilestoneEventDetailsBusinessService,
  ],
  declarations: [
    MilestoneEventListComponent,
    MilestoneEventDetailsComponent,
  ],
})
export class BuilderSetupMilestoneEventsModule {
}
